<template>
    <div class="social-master-orderlist white border-radius5 detail-orderlist">
        <div class="header-box module-header">
            <div
                    class="detail-tab-item"
                    :class="{on: tagName == 'noClose'}"
                    @click="tagName = 'noClose'"
            >{{$t('Position')}}</div>
            <div
              class="detail-tab-item"
              :class="{on: tagName == 'pending'}"
              @click="tagName = 'pending'"
            >{{$t('pending_order')}}</div>
            <div
                    class="detail-tab-item"
                    :class="{on: tagName == 'close'}"
                    @click="tagName = 'close'"
            >{{$t('User.reportCloseOrder')}}</div>
        </div>
        <div class="content">
            <order-not-close
              :date-time="dateTime"
              :need-order-source="needOrderSource"
              v-if="tagName == 'noClose'"
            ></order-not-close>
            <order-pending
              :date-time="dateTime"
              :need-order-source="needOrderSource"
              v-if="tagName == 'pending'"
            ></order-pending>
            <order-closed
              :date-time="dateTime"
              :need-order-source="needOrderSource"
              v-if="tagName == 'close'"
            ></order-closed>
        </div>
    </div>
</template>

<script>
  import orderPending from "@/components/user/details/common/order/order_pending";
  import orderNotClose from './order_notClose'
  import orderClosed from './order_closed'
  import { mapGetters } from 'vuex';
  export default {
    name: 'orderList',
    props: {
      dateTime: {
        type: Object,
      },
      needOrderSource: {
        type: Boolean,
        default: false,
      }
    },
    components:{
      orderNotClose,
      orderClosed,
      orderPending,
    },
    data() {
      return {
        tagName: 'noClose',
      };
    },
    computed: {
      ...mapGetters(['userInfo','detailsIsMaster']),
    },
  };
</script>
<style lang="scss">
    @import "../../../../../assets/scss/variable";
    .profit-words {
        color: $themeGreen;
        &.on {
            color: $themeColor;
        }
    }
    .detail-orderlist {
      .el-table::before {
        height: 0!important;
      }
    }
</style>
<style lang="scss" scoped>
.social-master-orderlist {
    .header-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        line-height: 62px;
    }
  .module-header {
    padding-left: 20px;
  }
}
</style>
<style lang="scss">
.detail-orderlist {
  .content {
    .header {
      padding: 24px;
      padding-bottom: 14px;

    }
  }
  .el-table {
    tr > th:first-child,
    tr > td:first-child {
      padding-left: 10px!important;
    }
  }
}
// pc样式
@media screen and (min-width: 768px){
  .content {
    .header {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;
      .date-picker-el {
        width: 260px;
      }
      .select-option-el {
        width: 130px;
      }
      .date-picker-el,
      .select-option-el {
        margin-right: 10px;
      }
    }
  }
}
@media screen and (max-width: 768px){
  .content {
    .header {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;

      .date-picker-el,
      .select-option-el {
        width: 100%;
      }
    }
  }

}
</style>
